import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Text from '../Text';
import { useThemeValue } from '../system';

function Heading(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level,
      restProps = _objectWithoutPropertiesLoose(_ref, ["level"]);

  var headingTheme = useThemeValue('heading');
  var lineHeights = useThemeValue('lineHeights');
  var index = level - 1;
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "h" + level,
    fontSize: index,
    lineHeight: lineHeights[index] + 'px'
  }, headingTheme, restProps));
}

export default Heading;